<div class="main-container" >
    <div class="right-content">
        <!-- Period buttons -->
        <div class="d-flex graph-filters">
            <div class="period-buttons">
                <div (click)="setGraphType('Daily')"
                    [ngClass]="{ 'selected-period': graphType === 'Daily', 'unselected-period': graphType !== 'Daily' }">
                {{ 'COMMON.DAILY' | translate}}
                </div>
                
                <div (click)="setGraphType('Monthly')"
                    [ngClass]="{ 'selected-period': graphType === 'Monthly', 'unselected-period': graphType !== 'Monthly' }">
                {{ 'COMMON.MONTHLY' | translate}}
                </div>
                
                <div (click)="setGraphType('Yearly')"
                    [ngClass]="{ 'selected-period': graphType === 'Yearly', 'unselected-period': graphType !== 'Yearly' }">
                {{ 'COMMON.YEARLY' | translate}}
                </div>
            </div>
            <div class="ms-auto d-flex align-items-center" (click)="toggleFilterPopup()">
                <div class="filter-icon">
                    <svg width="22" height="22" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.70123 20.3839V14.1314M5.70123 10.3799V3.87695M11.9998 20.1337V12.8804M11.9998 9.12903V4.12695M18.2984 20.3835V16.1319M18.2984 12.3807V3.87695M3.74609 13.8814H7.74982M9.99982 9.3789H13.9998M16.2498 15.8819H20.2498" stroke="#17171A" stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div class="filter-popup" *ngIf="isFilterPopupVisible">
                        <div>
                            {{ 'COMMON.BARS' | translate }}
                        </div>
                        <ng-container *ngFor="let ds of lineGraphData?.datasets; let i = index">
                            <label>
                            <input
                                type="checkbox"
                                [checked]="!chart?.chart?.getDatasetMeta(i)?.hidden"
                                (change)="toggleDatasetVisibility(i)"
                            />
                            {{ ds.label }}
                            </label>
                        </ng-container>
                    </div>
                </div>
                <div class="date">
                    <span class="arrow left-arrow" (click)="increasePage(1)">
                        <svg
                            class="primary-color"
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M16.2431 6.34317L14.8288 4.92896L7.75781 12L14.8289 19.0711L16.2431 17.6569L10.5862 12L16.2431 6.34317Z"
                            />
                        </svg>
                    </span>
                    <span class="value"
                    >{{ lineGraphData?.labels[0] }} -
                    {{ lineGraphData?.labels[lineGraphData.labels.length - 1] }}</span
                    >
                    <span class="arrow right-arrow" (click)="increasePage(-1)">
                        <svg
                            class="primary-color"
                            width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8 6.41422L9.4143 5L16.4853 12.0711L9.4143 19.1422L8 17.7279L13.6569 12.0711L8 6.41422Z"
                            />
                        </svg>
                    </span>
                </div>
            </div>
        </div>
        
        <div class="chart-container">
            <canvas baseChart
                    [data]="lineGraphData"
                    [options]="barChartOptions"
                    [plugins]="barChartPlugins"
                    [legend]="barChartLegend"
                    [type]="'bar'">
            </canvas>
        </div>
    </div>


</div>